import * as React from 'react';

import Footer from '@/components/layout/Footer';
import Header from '@/components/layout/Header';

type LayoutProps = {
  children: React.ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  showIconOnlyHeader?: boolean;
};

export default function Layout({
  children,
  hideHeader,
  hideFooter,
  showIconOnlyHeader = false
}: LayoutProps) {
  return (
    <>
      {!hideHeader && <Header showIconOnlyHeader={showIconOnlyHeader} />}
      <main className='cashrewards  mx-auto grid h-full w-full max-w-[1536px] grid-cols-xs gap-x-8 sm:grid-cols-sm md:grid-cols-md lg:grid-cols-lg xl:grid-cols-xl 2xl:grid-cols-2xl'>
        <div className='col-span-full min-h-[800px]'>{children}</div>
      </main>
      {hideFooter ? null : <Footer />}
    </>
  );
}
